class gTagEvents {

    constructor() {
        this.delegateBody = new Delegate(document.body);
        this.bindEvents();
        this.observeDOMChanges();
        this.handleIntersects();
        this.germanCheck();
    }

    germanCheck(){
      const redirected = localStorage.getItem('deRedirected');
      console.log('gTagEvents: Checking for redirected flag in window. Redirected: ', redirected);
      
      if (redirected) {
          const payload = {
          event:      'custom_utm_redirected',
          redirected: redirected
        };

        dataLayer.push(payload);
        console.log('gTagEvents: Redirected flag sent:', payload.redirected);
        localStorage.removeItem('deRedirected');
      }
    }

  

    bindEvents() {
        this.delegateBody.on("filters:applied", this.sendFiltersData.bind(this));
        this.delegateBody.on("filters:cleared", this.clearFiltersData.bind(this));
        this.delegateBody.on('click', '[data-action="apply-sort"]', this.sendSortByData.bind(this));

        this.delegateBody.on("click", '[name="checkout"]', this.handleCheckout.bind(this));
        this.delegateBody.on("click", '[data-ga="ga-send-select"]', this.handleSelectItem.bind(this));
        this.delegateBody.on("click", '[data-action="remove-item"]', this.removeFromCart.bind(this));
        this.delegateBody.on("click", '[data-action="remove-group"]', this.removeFromCart.bind(this));
        document.addEventListener("cart:add", this.sendAddToCart.bind(this));
    }

    sendSortByData(){
        const input = event.target.closest("input") || document.querySelector('input[name="sort_by"]:checked');
        if (!input) return

        if (this.lastSortBy === input.value) return;
        this.lastSortBy = input.value;

        dataLayer.push({
            event: "sort_applied",
            sort_by: input.value,
        });
    }

    sendFiltersData() {
        const filtersList = [];
        const filterCheckboxes = document.querySelectorAll('.inputFilterCheckbox:checked');

        filterCheckboxes.forEach(checkbox => {
            filtersList.push(checkbox.dataset.filterName + ":" + checkbox.dataset.optionLabel);
        });

        if (!filtersList.length) return;

        if (JSON.stringify(this.lastFiltersList) === JSON.stringify(filtersList)) return;
        this.lastFiltersList = filtersList;
        
        dataLayer.push({
            event: "filter_applied",
            filter_by: filtersList,
        });      
    }

    clearFiltersData() {
    
        dataLayer.push({
            event: "clear_filters",
            filter_by: [],
        });

        this.sendSortByData();
    }

    sendAddToCart() {
        const items = event.detail; // Assuming this contains all items (like cartDetails array)
    
      
        if (dataLayer) {
          dataLayer.push({ ecommerce: null }); // Clear previous ecommerce data
      
          let ecommerceData = {
            'event': 'add_to_cart_custom',
            'ecommerce': {
              'value': 0, // We'll calculate the total value below
              'items': []
            }
          };
      
          // Loop through each item in the array and add it to the ecommerce data
          items.forEach((item) => {
            const price = parseInt(item.price / 100);
            const quantity = parseInt(item.quantity);
            
            // Add each item's details
            ecommerceData.ecommerce.items.push({
              'item_id': item.variantId || item.variant_id || item.sku,
              'item_variant': item.variantTitle,
              'item_name': item.productName,
              'price': price,
              'quantity': quantity
            });
      
            // Update the total value
            ecommerceData.ecommerce.value += price * quantity;
          });
          console.log('[GTM] add_to_cart_custom (item_id=variantId)', ecommerceData);
          
          // Push the data to the dataLayer
          dataLayer.push(ecommerceData);
        }
    }
      
    
    handleIntersects() {
        const allIntersections = document.body.querySelectorAll("[data-gtag-intersection]");
    
        allIntersections.forEach((item) => {
          // It's a good practice to check if the item is already being observed
          // to avoid attaching multiple observers to the same element.
          if (item.dataset.observed !== "true") {
            const observer = new IntersectionObserver(
              this.handleIntersection.bind(this),
              {
                root: null, // Use the viewport as the root
                rootMargin: "0px",
                threshold: 0.1, // Adjust the threshold as per your requirement
              }
            );
    
            observer.observe(item);
            // Mark the element as observed
            item.dataset.observed = "true";
          }
        });
      }
    
      observeDOMChanges() {
        const observer = new MutationObserver((mutationsList, observer) => {
          // For each mutation record, we look for added nodes
          for (const mutation of mutationsList) {
            if (mutation.addedNodes.length) {
              // If there are added nodes, we call handleIntersects to check for new items
              this.handleIntersects();
            }
          }
        });
    
        // Start observing the document body for added nodes and subtree modifications
        observer.observe(document.body, {
          childList: true, // Observe direct children
          subtree: true, // and all descendants
          attributes: false // Set to true if you also want to observe attribute changes
        });
    }
    
    handleIntersection(entries) {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            let data = false;
    
            try {
              data = JSON.parse(
                entry.target.querySelector('script[type="application/ld+json"]')
                  .textContent
              );
            } catch(e) {
              console.log("JSON parse failed", e);
            }
    
            if (!dataLayer || !data) return;
            if (data.event === 'view_item_pdp') {
              console.log('[GTM] view_item_pdp', data);
            }
            if (data?.ecommerce?.items?.length) {
              console.log('[GTM] intersection ecommerce event', data.event, data.ecommerce.items.map((i) => i.item_id));
            }
            dataLayer.push({ ecommerce: null });
            dataLayer.push(data);
          }
        });
    }
    
    handleCheckout() {
        const target = document.querySelector(".cartCheckout--Button");
        const settings = JSON.parse(target.dataset.settings);
    
        if (!dataLayer || !settings) return;
    
        dataLayer.push({ ecommerce: null });
        dataLayer.push(settings);
    }
    
    handleSelectItem(event) {
        let target = event.target;
        if (event.target.classList.contains('product-card_favorites-container')) return;
    
        if (event.target.dataset.ga != "ga-send-select") {
          target = event.target.closest('[data-ga="ga-send-select"]');
        }
    
        const settings = JSON.parse(target.dataset.settings);
    
        if (!dataLayer || !settings) return;
    
        console.log('[GTM] select_item', settings);
        dataLayer.push({
          event: "select_item",
          selected_item_list_id: settings.list_id,
          selected_item_list_name: settings.list_name,
          selected_items: [
            {
              item_id: settings.item_id,
              item_name: settings.item_name,
              price: settings.price,
              item_list_id: settings.list_id,
              item_list_name: settings.list_name,
            },
          ],
        });
    }
    
    removeFromCart(event) {
        let target = event.target;
    
        const settings = JSON.parse(target.closest("[data-remove]").dataset.remove);
        if (!dataLayer || !settings) return;
    
        console.log('[GTM] remove_from_cart', settings);
        dataLayer.push({
          event: "remove_from_cart",
          remove: {
            value: settings.value, // The total value of the items being removed.
            items: [
              {
                item_id: settings.item_id, // ID of the product
                item_name: settings.item_name, // Name of the product
                price: settings.price, // Price of the product
                quantity: settings.quantity, // Number of items removed
              },
            ],
          },
        });
    }

      static sendSignal(redirected) {
        if (!window.dataLayer) return;
        window.dataLayer.push({
            event: "utm_redirected",
            redirected: Boolean(redirected)
        });
    }

}

new gTagEvents();